import { render } from "./TicketAutocomplete.vue?vue&type=template&id=1ea46bab&ts=true"
import script from "./TicketAutocomplete.ts?vue&type=script&lang=ts"
export * from "./TicketAutocomplete.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__